import { JSX } from 'react';
import ArrowUp from '../../assets/images/icons/arrow-up.svg';

type CursorPaginationProps = {
  onNext: () => void;
  onPrevious: () => void;
  hasNext: boolean;
  page: number;
  totalPages: number;
  onPageClick: (index: number) => void;
};

const CursorPagination = ({
  onNext,
  onPrevious,
  hasNext,
  page,
  totalPages,
  onPageClick,
}: CursorPaginationProps): JSX.Element => {
  const getPaginationNumbers = (): (number | string)[] => {
    const pages: (number | string)[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(
          1,
          '...',
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(1, '...', page - 1, page, page + 1, '...', totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="pagination">
      <ul>
        <li
          onClick={page > 1 ? onPrevious : undefined}
          onKeyUp={e => {
            (e.key === 'Enter' || e.key === ' ') && page > 1
              ? onPrevious()
              : undefined;
          }}
          className={page <= 1 ? 'disabled' : ''}
          tabIndex={page <= 1 ? -1 : 0}
        >
          <a className="pagination-btn previous">
            <ArrowUp className="icon icon-arrow-up" />
          </a>
        </li>

        {getPaginationNumbers().map((p, i) => (
          <li
            key={i}
            className={p === page ? 'active' : ''}
            onClick={typeof p === 'number' ? () => onPageClick(p) : undefined}
            onKeyUp={e =>
              (e.key === 'Enter' || e.key === ' ') && typeof p === 'number'
                ? onPageClick(p)
                : undefined
            }
            tabIndex={0}
          >
            <a>{p}</a>
          </li>
        ))}

        <li
          onClick={hasNext ? onNext : undefined}
          onKeyUp={e =>
            (e.key === 'Enter' || e.key === ' ') && hasNext
              ? onNext()
              : undefined
          }
          className={!hasNext ? 'disabled' : ''}
          tabIndex={!hasNext ? -1 : 0}
        >
          <a className="pagination-btn next">
            <ArrowUp className="icon icon-arrow-up" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default CursorPagination;
